import styled from "@emotion/styled";

import TemplateHeader from "@/components/templates/TemplateHeader";
import TemplateNavigation from '@/components/templates/TemplateNavigation'

const Layout = styled.div``;

Layout.Header = styled(TemplateHeader)`
  height: 80px !important;
  padding: 10px 0;
  position: relative;
`;

Layout.Logo = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

Layout.LogoImage = styled.img`
  height: 70px;
  justify-self: flex-start;
`;

Layout.LogoText = styled.span`
  font-size: 22px;
  font-weight: 900;
  margin-top: 0.5em;
`;

Layout.Menu = styled(TemplateNavigation)`
  display: flex;
  align-items: center;
  gap: 32px;
`;

export default Layout;
